export const setPublicationZIndex = (
  value: "var(--zindex-dropdown-content)" | "var(--zindex-publication)",
  publicationRef: React.RefObject<HTMLDivElement>
) => {
  publicationRef?.current?.style.setProperty("z-index", value);
};
